import React from "react";
import styles from "./style.module.css";

import NumberFormat from "react-number-format";
import { Popover, OverlayTrigger } from "react-bootstrap";

import Select from "react-select";

import RadarChart from "components/Project/RadarChart";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import numeral from "numeral";

const BAD_OFFSET = 5;

export default class CompareWaterfall extends React.PureComponent {
  renderBar(bar, index) {
    const { roundTotal, isRequirementsGathering, showLabel, isCompare } = this.props;

    return (
      <OverlayTrigger
        key={index}
        placement="top"
        trigger={["hover", "focus"]}
        overlay={
          <Popover id="popover-positioned-top" title={bar.label}>
            {bar.tooltip &&
              bar.tooltip.map((tooltip, tIndex) => (
                <div key={tIndex}>
                  {tooltip.value && (
                    <div className={styles.tooltipHolder}>
                      <span className={styles.tooltipInfo}>
                        {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Value: "}
                      </span>
                      <span className={styles.tooltipNumber}>{numeral(tooltip.value).format("0.0a")}</span>
                    </div>
                  )}
                  {tooltip.count && (
                    <div className={styles.tooltipHolder}>
                      <span className={styles.tooltipInfo}>{"Count:"}</span>
                      <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                    </div>
                  )}
                </div>
              ))}
          </Popover>
        }
      >
        <div
          className={styles.bar + " " + (isRequirementsGathering ? styles.barMargin : "")}
          style={{
            width: bar.width,
            marginLeft: bar.marginLeft,
            background: bar.color,
            flexGrow: bar.isHidden && 0,
            height: bar.isHidden && "0px"
          }}
        >
          {showLabel ? (
            <div
              className={styles.wLabel}
              style={
                bar.isTotal
                  ? {
                      color: isCompare ? "#333" : "white",
                      marginLeft: isCompare ? "-100px" : "0px"
                    }
                  : { marginLeft: isCompare ? "-100px" : "0px" }
              }
            >
              {bar.label}
            </div>
          ) : (
            <div />
          )}
          {bar.showTotalVal && (
            <div className={styles.barValue}>
              <NumberFormat
                value={roundTotal ? Math.round(bar.value) : bar.value.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
              />
            </div>
          )}
        </div>
      </OverlayTrigger>
    );
  }

  renderTransactions(k) {
    const { project, viewingScenarioIndex, compareScenarioIndex, viewScenario, compareScenario } = this.props;

    if (
      viewingScenarioIndex === undefined ||
      compareScenarioIndex === undefined ||
      viewScenario === undefined ||
      compareScenario === undefined
    ) {
      return <div />;
    }

    const setup = viewScenario.scenarios[k] ? viewScenario.scenarios[k].setup.data : undefined;

    if (setup === undefined) {
      return <div />;
    }

    const vScenarioName = viewScenario.originalScenarios.name;
    const cScenarioName = compareScenario.originalScenarios.name;

    const data = [
      {
        assumption: setup.truePositiveLabel,
        [vScenarioName]:
          (viewScenario.scenarios[k].setup.data.truePositive /
            Math.max(
              viewScenario.scenarios[k].setup.data.truePositive,
              compareScenario.scenarios[k].setup.data.truePositive
            )) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].setup.data.truePositive /
            Math.max(
              compareScenario.scenarios[k].setup.data.truePositive,
              viewScenario.scenarios[k].setup.data.truePositive
            )) *
          100
      },
      {
        assumption: setup.falsePositiveLabel,
        [vScenarioName]:
          (viewScenario.scenarios[k].setup.data.falsePositive /
            Math.max(
              viewScenario.scenarios[k].setup.data.falsePositive,
              compareScenario.scenarios[k].setup.data.falsePositive
            )) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].setup.data.falsePositive /
            Math.max(
              compareScenario.scenarios[k].setup.data.falsePositive,
              viewScenario.scenarios[k].setup.data.falsePositive
            )) *
          100
      },
      {
        assumption: setup.trueNegativeLabel,
        [vScenarioName]:
          (viewScenario.scenarios[k].setup.data.trueNegative /
            Math.max(
              viewScenario.scenarios[k].setup.data.trueNegative,
              compareScenario.scenarios[k].setup.data.trueNegative
            )) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].setup.data.trueNegative /
            Math.max(
              compareScenario.scenarios[k].setup.data.trueNegative,
              viewScenario.scenarios[k].setup.data.trueNegative
            )) *
          100
      },
      {
        assumption: setup.falseNegativeLabel,
        [vScenarioName]:
          (viewScenario.scenarios[k].setup.data.falseNegative /
            Math.max(
              viewScenario.scenarios[k].setup.data.falseNegative,
              compareScenario.scenarios[k].setup.data.falseNegative
            )) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].setup.data.falseNegative /
            Math.max(
              compareScenario.scenarios[k].setup.data.falseNegative,
              viewScenario.scenarios[k].setup.data.falseNegative
            )) *
          100
      },
      {
        assumption: "Total Population",
        [vScenarioName]:
          (viewScenario.scenarios[k].total /
            Math.max(viewScenario.scenarios[k].total, compareScenario.scenarios[k].total)) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].total /
            Math.max(compareScenario.scenarios[k].total, viewScenario.scenarios[k].total)) *
          100
      },
      {
        assumption: "Percentage Processed",
        [vScenarioName]:
          (viewScenario.scenarios[k].totalWorked /
            Math.max(viewScenario.scenarios[k].totalWorked, compareScenario.scenarios[k].totalWorked)) *
          100,
        [cScenarioName]:
          (compareScenario.scenarios[k].totalWorked /
            Math.max(compareScenario.scenarios[k].totalWorked, viewScenario.scenarios[k].totalWorked)) *
          100
      }
    ];

    return (
      <div className={styles.tRadarChart} key={"t_" + k}>
        <RadarChart
          data={data}

          /*
          Object.keys(
            viewScenario.scenarios[k].setup.data.customValues
          ).map((c) => ({
            assumption: c,
            ["Scenario " + viewScenario.originalScenarios.name]:
              (viewScenario.scenarios[k].setup.data.customValues[c] * 100) /
              Object.keys(viewScenario.scenarios).reduce(
                (a, b) =>
                  Math.max(
                    a,
                    viewScenario.scenarios[b].setup.data.customValues[c]
                  ),
                0
              ),
            ["Scenario " + compareScenario.originalScenarios.name]:
              (compareScenario.scenarios[k].setup.data.customValues[c] * 100) /
              Object.keys(compareScenario.scenarios).reduce(
                (a, b) =>
                  Math.max(
                    a,
                    compareScenario.scenarios[b].setup.data.customValues[c]
                  ),
                0
              ),
          }))}
          */
        />
      </div>
    );
  }

  renderAssumption(k) {
    const { project, viewingScenarioIndex, compareScenarioIndex, viewScenario, compareScenario } = this.props;

    if (
      viewingScenarioIndex === undefined ||
      compareScenarioIndex === undefined ||
      project.settings.scenarios[viewingScenarioIndex][k] === undefined ||
      project.settings.scenarios[compareScenarioIndex][k] === undefined
    ) {
      return <div />;
    }

    const impacts = [
      { value: "conversionGain", label: "truePositiveLabel" },
      { value: "conversionCost", label: "falsePositiveLabel" },
      { value: "conversionSaved", label: "trueNegativeLabel" },
      { value: "conversionMissed", label: "falseNegativeLabel" }
    ];

    return (
      <div className={styles.radarChart} key={k}>
        <RadarChart
          data={
            Object.keys(viewScenario.scenarios[k].setup.data.customValues).length > 0
              ? Object.keys(viewScenario.scenarios[k].setup.data.customValues).map((c) => ({
                  assumption: c,
                  [viewScenario.originalScenarios.name]:
                    (viewScenario.scenarios[k].setup.data.customValues[c] * 100) /
                    Object.keys(viewScenario.scenarios)
                      .reduce((a, b) => Math.max(a, viewScenario.scenarios[b].setup.data.customValues[c]), 0)
                      .toFixed(2),
                  [compareScenario.originalScenarios.name]:
                    (compareScenario.scenarios[k].setup.data.customValues[c] * 100) /
                    Object.keys(compareScenario.scenarios)
                      .reduce((a, b) => Math.max(a, compareScenario.scenarios[b].setup.data.customValues[c]), 0)
                      .toFixed(2)
                }))
              : impacts.map((val) => ({
                  assumption: viewScenario.scenarios[k].setup.data[val.label],
                  [viewScenario.originalScenarios.name]:
                    viewScenario.scenarios[k].setup.data[val.value] /
                    Math.max(
                      viewScenario.scenarios[k].setup.data[val.value],
                      compareScenario.scenarios[k].setup.data[val.value]
                    ),
                  [compareScenario.originalScenarios.name]:
                    compareScenario.scenarios[k].setup.data[val.value] /
                    Math.max(
                      viewScenario.scenarios[k].setup.data[val.value],
                      compareScenario.scenarios[k].setup.data[val.value]
                    )
                }))
          }
        />
      </div>
    );
  }

  renderCompareBar(bar, index) {
    const {
      bars,
      roundTotal,
      viewScenario,
      compareScenario,
      compareElement,
      isRequirementsGathering,
      updateViewScenarioIndex,
      updateCompareScenarioIndex,
      compareScenarioIndex,
      viewingScenarioIndex,
      project,
      showLabel,
      isCompare
    } = this.props;

    return (
      <div
        className={
          styles.compareBar +
          " " +
          (isRequirementsGathering ? styles.barMargin : "") +
          " " +
          (index === 0 || bar.isTotal === true ? styles.outerBar : "")
        }
        style={{
          width: "100%",
          background: "transparent",
          zIndex: index === 0 ? 6 : 5
        }}
        key={index}
      >
        <OverlayTrigger
          key={index}
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id="popover-positioned-top" title={bar.label}>
              {bar.tooltip &&
                bar.tooltip.map((tooltip, tIndex) => (
                  <div key={tIndex}>
                    {tooltip.value && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>
                          {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Value: "}
                        </span>
                        <span className={styles.tooltipNumber}>{numeral(tooltip.value).format("0.0a")}</span>
                      </div>
                    )}
                    {tooltip.count && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>{"Count:"}</span>
                        <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                      </div>
                    )}
                  </div>
                ))}
            </Popover>
          }
        >
          <div
            className={styles.tinyBar}
            style={{
              background: bar.color,
              marginLeft: parseFloat(bar.marginLeft.replace("%", "")) / BAD_OFFSET + "%",
              width: parseFloat(bar.width.replace("%", "")) / BAD_OFFSET + "%"
            }}
          >
            <span
              style={{
                marginLeft: "5px",
                color: bar.width && parseFloat(bar.width.replace("%", "")) < 10 ? "black" : "white"
              }}
            >
              {numeral(bar.value).format("0.0a")}
            </span>
          </div>
        </OverlayTrigger>
        {bar.isTotal !== true && (
          <div
            className={styles.tBarLine + " " + (index === 0 || index === bars.length - 1 ? styles.tBarLineOuter : "")}
            style={{
              left:
                bar.value > 0
                  ? parseFloat(bar.marginLeft.replace("%", "")) / BAD_OFFSET +
                    parseFloat(bar.width.replace("%", "")) / BAD_OFFSET +
                    "%"
                  : parseFloat(bar.marginLeft.replace("%", "")) / BAD_OFFSET + "%"
            }}
          />
        )}
        {index === 0 || bar.isTotal ? (
          <div className={styles.wLabelSelect}>
            <div
              className={styles.midIcon}
              style={{
                background: bar.color
              }}
            />
            <div className={styles.sCompHolder}>
              <Select
                options={
                  project && project.settings && project.settings.originalScenarios
                    ? project.settings.originalScenarios.map((s, i) => ({
                        label: s.name,
                        value: i
                      }))
                    : []
                }
                value={{
                  label: bar.label,
                  value: index === 0 ? viewingScenarioIndex : compareScenarioIndex
                }}
                menuPlacement={index === 0 ? "bottom" : "top"}
                onChange={(val) =>
                  index === 0 ? updateViewScenarioIndex(val.value) : updateCompareScenarioIndex(val.value)
                }
              />
            </div>
          </div>
        ) : (
          <div
            className={styles.wLabelCompare}
            style={
              bar.isTotal
                ? {
                    color: "#333",
                    marginLeft: "-200px"
                  }
                : { marginLeft: index === 0 || bar.isTotal ? "-200px" : "-188px" }
            }
          >
            <div
              className={styles.midIcon}
              style={{
                background: bar.color
              }}
            />
            {bar.label}
          </div>
        )}
        {index === 0 ? (
          <div className={styles.wRight} style={{ borderTop: "none" }}>
            {/*
            <div
              className={styles.explainHolder}
              style={{ fontWeight: "bold" }}
            >
              {"Scenario " +
                viewScenario.originalScenarios.name +
                " has " +
                (
                  Math.abs(
                    (viewScenario.scenarioStats[compareElement.toLowerCase()] -
                      compareScenario.scenarioStats[
                        compareElement.toLowerCase()
                      ]) /
                      Math.abs(
                        compareScenario.scenarioStats[
                          compareElement.toLowerCase()
                        ]
                      )
                  ) * 100
                ).toFixed(2) +
                "% " +
                (viewScenario.scenarioStats[compareElement.toLowerCase()] >
                compareScenario.scenarioStats[compareElement.toLowerCase()]
                  ? "higher "
                  : "lower ") +
                compareElement +
                " than Scenario " +
                compareScenario.originalScenarios.name}
            </div>
            */}
          </div>
        ) : (
          bar.isTotal !== true && (
            <div className={styles.wRight} style={index === 1 ? { borderTop: "none" } : {}}>
              {this.renderAssumption(bar.label)}
              {this.renderTransactions(bar.label)}
              {this.renderDrivers(bar.label)}
              {this.renderExplanation(bar.label)}
            </div>
          )
        )}
      </div>
    );
  }

  renderExplanation(label) {
    const { modelGroups, viewScenario, compareScenario, compareElement } = this.props;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValue &&
      modelGroups.drilldownValue.filter((v) => v.drilldownValue === label).length > 0
        ? modelGroups.drilldownValue.filter((v) => v.drilldownValue === label)[0]
        : undefined;

    const topDeltas =
      viewScenario &&
      compareScenario &&
      viewScenario.scenarios &&
      compareScenario.scenarios &&
      viewScenario.scenarios[label] &&
      compareScenario.scenarios[label] &&
      viewScenario.scenarios[label].setup &&
      viewScenario.scenarios[label].setup.data &&
      viewScenario.scenarios[label].setup.data.customValues &&
      compareScenario.scenarios[label].setup &&
      compareScenario.scenarios[label].setup.data &&
      compareScenario.scenarios[label].setup.data.customValues
        ? Object.keys(viewScenario.scenarios[label].setup.data.customValues)
            .map((k) => ({
              view: viewScenario.scenarios[label].setup.data.customValues[k],
              compare: compareScenario.scenarios[label].setup.data.customValues[k],
              delta:
                ((Number(compareScenario.scenarios[label].setup.data.customValues[k]) -
                  Number(viewScenario.scenarios[label].setup.data.customValues[k])) /
                  Number(viewScenario.scenarios[label].setup.data.customValues[k])) *
                100,
              isInf: Number(compareScenario.scenarios[label].setup.data.customValues[k]) === 0,
              assumption: k,
              label: label
            }))
            .filter((s) => s.delta != 0)
            .sort((a, b) => b.delta - a.delta)
        : [];

    return (
      viewScenario &&
      compareScenario &&
      viewScenario.scenarios &&
      compareScenario.scenarios &&
      viewScenario.scenarios[label] &&
      compareScenario.scenarios[label] && (
        <div
          className={styles.explainHolder}
          style={topDeltas && topDeltas.length > 0 ? { justifyContent: "flex-start" } : {}}
        >
          {/*
          <div>
            {viewScenario.scenarios[label].profit ===
            compareScenario.scenarios[label].profit
              ? compareElement +
                " for " +
                label +
                " is the same across scenarios"
              : compareElement +
                " for " +
                label +
                " is " +
                (
                  Math.abs(
                    (viewScenario.scenarios[label][
                      compareElement.toLowerCase()
                    ] -
                      compareScenario.scenarios[label][
                        compareElement.toLowerCase()
                      ]) /
                      Math.abs(
                        compareScenario.scenarios[label][
                          compareElement.toLowerCase()
                        ]
                      )
                  ) * 100
                ).toFixed(2) +
                "% lower when compared to Scenario " +
                compareScenario.originalScenarios.name}
          </div>
        */}
          {topDeltas && topDeltas.length > 0 && (
            <div className={styles.topDeltas}>
              {topDeltas.map((d, i) =>
                d.isInf ? (
                  <div className={styles.driverItem} key={i}>
                    <span
                      className={
                        styles.botDelta + " " + (d.delta > 0 ? styles.increase : styles.decrease) + " " + styles.absText
                      }
                    >
                      {d.delta !== undefined ? (d.delta > 0 ? "+" : "") + d.view : d.delta}
                    </span>
                    <div>
                      <div className={styles.dName}>{d.assumption}</div>
                    </div>
                  </div>
                ) : (
                  <div className={styles.driverItem} key={i}>
                    <span className={styles.botDelta + " " + (d.delta > 0 ? styles.increase : styles.decrease)}>
                      {d.delta !== undefined
                        ? (d.delta > 0 ? "+" : "") + Math.round(d.delta.toFixed(2)) + "%"
                        : d.delta}
                    </span>
                    <div>
                      <div className={styles.dName}>{d.assumption}</div>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      )
    );
  }

  renderDrivers(label) {
    const { modelGroups, compareScenario, viewScenario } = this.props;

    const cModel =
      compareScenario && compareScenario.scenarios && compareScenario.scenarios[label]
        ? compareScenario.scenarios[label].model
        : undefined;
    const vModel =
      viewScenario && viewScenario.scenarios && viewScenario.scenarios[label]
        ? viewScenario.scenarios[label].model
        : undefined;

    const topDrivers =
      compareScenario &&
      compareScenario.scenarios &&
      compareScenario.scenarios[label] &&
      compareScenario.scenarios[label].topDrivers &&
      viewScenario &&
      viewScenario.scenarios &&
      viewScenario.scenarios[label] &&
      viewScenario.scenarios[label].topDrivers
        ? compareScenario.scenarios[label].topDrivers
            .map((d) => ({
              name: d.name,
              value:
                viewScenario.scenarios[label].topDrivers.filter((v) => v.name === d.name).length > 0
                  ? d.value - viewScenario.scenarios[label].topDrivers.filter((v) => v.name === d.name)[0].value
                  : d.value,
              absValue:
                viewScenario.scenarios[label].topDrivers.filter((v) => v.name === d.name).length > 0
                  ? Math.abs(
                      d.value - viewScenario.scenarios[label].topDrivers.filter((v) => v.name === d.name)[0].value
                    )
                  : Math.abs(d.value)
            }))
            .sort((a, b) => b.absValue - a.absValue)
        : [];

    return cModel && vModel && cModel.id === vModel.id ? (
      <div className={styles.driversHolderEmpty}>{"Same Model"}</div>
    ) : (
      <div className={styles.driversHolder}>
        {topDrivers
          .filter((m, i) => i < 5)
          .map((m, i) => (
            <div className={styles.driverItem} key={i}>
              <span className={styles.botDelta + " " + (m.value > 0 ? styles.increase : styles.decrease)}>
                {m.value !== undefined
                  ? (m.value > 0 ? "+" : "") + Math.round(m.value.toFixed(2) * 100) + "%"
                  : m.value}
              </span>
              <div>
                <div className={styles.dName}>{m.name}</div>
              </div>
            </div>
          ))}
      </div>
    );
  }

  renderStackedBar(bar, index) {
    const { isWide, handleOpenDeploy } = this.props;

    return (
      <div key={index} className={styles.barHolder}>
        <div
          className={bar.isSelected ? styles.bSWideLabel : styles.bWideLabel}
          onClick={() => handleOpenDeploy(bar.label)}
        >
          {bar.label}
        </div>
        <OverlayTrigger
          key={index}
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id="popover-positioned-top" title={bar.label}>
              {bar.tooltip &&
                bar.tooltip.map((tooltip, tIndex) => (
                  <div key={tIndex}>
                    {tooltip.value && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>
                          {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Value: "}
                        </span>
                        <span className={styles.tooltipNumber}>
                          <NumberFormat
                            value={
                              !bar.tooltipLabel && Math.abs(tooltip.value) < 1000
                                ? tooltip.value.toFixed(2)
                                : Math.round(tooltip.value)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </span>
                      </div>
                    )}
                    {tooltip.count && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>{"Count:"}</span>
                        <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                      </div>
                    )}
                  </div>
                ))}
            </Popover>
          }
        >
          <div className={bar.isSelected ? styles.selectedBHolder : styles.bHolder}>
            <div
              className={styles.bar}
              style={{
                width: bar.width,
                marginLeft: isWide ? "35%" : "50%",
                background: bar.value > 0 ? "rgb(146, 207, 72)" : "rgb(235, 51, 43)",
                flexGrow: bar.isHidden && 0,
                overflow: "visible"
              }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  render() {
    const {
      bars,
      totalLabel,
      showTotalVal,
      isStacked,
      isWide,
      isCompare,
      useTotal,
      hideTotal,
      hideLabels,
      isFlex,
      largest
    } = this.props;

    const colors = ["#92cf48", "#eb332b", "#b1d36f", "#d7a4aa", "var(--aible-color)"];

    let min = undefined;
    let max = undefined;
    let current = 0;

    const maxVal = Math.max.apply(
      Math,
      bars.map((b) => b.value)
    );
    const minVal = Math.min.apply(
      Math,
      bars.map((b) => b.value)
    );

    for (const bar of bars) {
      if (bar.isHidden !== true) {
        current += bar.value;

        if (current < min || min === undefined) {
          min = current;
        }
        if (current > max || max === undefined) {
          max = current;
        }
      }
    }

    if (max > 0 && min > 0) {
      min = 0;
    }

    if (max < 0 && min < 0) {
      max = 0;
    }

    if (isStacked) {
      max = isWide ? 170 : useTotal ? maxVal * 2 : 200;
    }

    if (largest) {
      max = largest;
    }

    let totalDelta = max - min;

    let rBars = [];
    let rCurrent = 0;
    let tCurrent = 0;
    let index = 0;

    const pColors = ["rgb(91, 207, 115)", "rgb(91, 207, 115)"];

    const nColors = ["rgb(192, 62, 89)", "rgb(192, 62, 89)"];

    for (const bar of bars) {
      const start = Math.min(rCurrent, rCurrent + bar.value);
      const end = Math.max(rCurrent, rCurrent + bar.value);

      rBars[index] = {
        ...bar,
        value: bar.value,
        marginLeft: isStacked ? 0 : ((start - min) / totalDelta) * 100 + "%",
        width: largest === 0 || bar.value === 0 ? 0 + "%" : ((end - start) / totalDelta) * 100 + "%",
        tooltip: [{ value: bar.value, count: bar.count }],
        color:
          index === 0
            ? "#EF7E54"
            : bar.color
              ? bar.color
              : bar.value > 0
                ? bar.value === maxVal
                  ? pColors[0]
                  : pColors[1]
                : bar.value === minVal
                  ? nColors[0]
                  : nColors[1]
      };

      if (bar.isHidden !== true) {
        tCurrent += bar.value;
      }

      rCurrent += bar.value;

      index++;
    }

    const marginLeft =
      tCurrent < 0
        ? (Math.abs(min - tCurrent) / totalDelta) * 100
        : min < 0
          ? (Math.abs(min) / totalDelta) * 100
          : min === 0
            ? 0
            : (Math.abs(min - tCurrent) / totalDelta) * 100;

    if (isStacked !== true && hideTotal !== true) {
      rBars.push({
        value: tCurrent,
        marginLeft: marginLeft + "%",
        width: tCurrent === 0 ? "0%" : (((tCurrent < 0 ? 0 : tCurrent) - min) / totalDelta) * 100 - marginLeft + "%",
        color: "#7E69D7",
        label: totalLabel,
        tooltip: [{ value: tCurrent }],
        showTotalVal: showTotalVal,
        isTotal: true,
        tooltipLabel: rBars && rBars.length > 0 ? rBars[0].tooltipLabel : undefined
      });
    }

    return (
      <div
        className={
          isCompare ? styles.compareMatrixHolder : isFlex ? styles.flexValueMatrixHolder : styles.valueMatrixHolder
        }
        style={
          isStacked
            ? { background: "transparent", width: "100%" }
            : {
                background: "transparent",
                overflowX: isCompare ? "visible" : "hidden"
              }
        }
      >
        {rBars.map((bar, index) =>
          isStacked
            ? this.renderStackedBar(bar, index)
            : isCompare
              ? this.renderCompareBar(bar, index)
              : this.renderBar(bar, index)
        )}
        {min < 0 && !isStacked && (
          <div
            className={styles.zero}
            style={{
              marginLeft: ((0 - min) / totalDelta) * 100 + "%"
            }}
          />
        )}
      </div>
    );
  }
}
